module.exports = 
    [  
        {  
            "name":"188 East 78th Street",
            "architect":"Project Architect",
            "projdescription": "Witkoff Residence",
            "link": "Witkoff Residence",
            "cover": "Witkoff-Residence/1.jpg",
            "images": [
                {"link": "Witkoff-Residence/1.jpg", "caption": "This will be the image's caption."},
                {"link": "Witkoff-Residence/2.jpg", "caption": "This will be the image's caption."},
                {"link": "Witkoff-Residence/3.jpg", "caption": "This will be the image's caption."},
                {"link": "Witkoff-Residence/4.jpg", "caption": "This will be the image's caption."},
                {"link": "Witkoff-Residence/5.jpg", "caption": "This will be the image's caption."},
                {"link": "Witkoff-Residence/6.jpg", "caption": "This will be the image's caption."},
                {"link": "Witkoff-Residence/7.jpg", "caption": "This will be the image's caption."},
                {"link": "Witkoff-Residence/8.jpg", "caption": "This will be the image's caption."},
                {"link": "Witkoff-Residence/9.jpg", "caption": "This will be the image's caption."},
                {"link": "Witkoff-Residence/10.jpg", "caption": "This will be the image's caption."},
                {"link": "Witkoff-Residence/11.jpg", "caption": "This will be the image's caption."},
                {"link": "Witkoff-Residence/12.jpg", "caption": "This will be the image's caption."},
                {"link": "Witkoff-Residence/13.jpg", "caption": "This will be the image's caption."},
                {"link": "Witkoff-Residence/14.jpg", "caption": "This will be the image's caption."},
                {"link": "Witkoff-Residence/15.jpg", "caption": "This will be the image's caption."},
                {"link": "Witkoff-Residence/16.jpg", "caption": "This will be the image's caption."},
                {"link": "Witkoff-Residence/17.jpg", "caption": "This will be the image's caption."},
                {"link": "Witkoff-Residence/18.jpg", "caption": "This will be the image's caption."},
                {"link": "Witkoff-Residence/19.jpg", "caption": "This will be the image's caption."},
                {"link": "Witkoff-Residence/20.jpg", "caption": "This will be the image's caption."},
                {"link": "Witkoff-Residence/21.jpg", "caption": "This will be the image's caption."},
                {"link": "Witkoff-Residence/22.jpg", "caption": "This will be the image's caption."},
                {"link": "Witkoff-Residence/23.jpg", "caption": "This will be the image's caption."},
                {"link": "Witkoff-Residence/24.jpg", "caption": "This will be the image's caption."},
                {"link": "Witkoff-Residence/25.jpg", "caption": "This will be the image's caption."},
                {"link": "Witkoff-Residence/26.jpg", "caption": "This will be the image's caption."},
                {"link": "Witkoff-Residence/27.jpg", "caption": "This will be the image's caption."},
                {"link": "Witkoff-Residence/28.jpg", "caption": "This will be the image's caption."},
                {"link": "Witkoff-Residence/29.jpg", "caption": "This will be the image's caption."},
                {"link": "Witkoff-Residence/30.jpg", "caption": "This will be the image's caption."},
                {"link": "Witkoff-Residence/31.jpg", "caption": "This will be the image's caption."},
                {"link": "Witkoff-Residence/32.jpg", "caption": "This will be the image's caption."},
                {"link": "Witkoff-Residence/33.jpg", "caption": "This will be the image's caption."},
                {"link": "Witkoff-Residence/34.jpg", "caption": "This will be the image's caption."},
                {"link": "Witkoff-Residence/35.jpg", "caption": "This will be the image's caption."},
                {"link": "Witkoff-Residence/36.jpg", "caption": "This will be the image's caption."},
                {"link": "Witkoff-Residence/37.jpg", "caption": "This will be the image's caption."},
            ],
            "description": "This will be the project's description once TopBunk Tech acquires all of the needed resources. Please be patient while we wait for those resources to arrive.",
            "about": "This is an area where United Builders Group can inform the user about the project. This could include start and end dates, location of the project, or any information United Builders Group would like to share.",
            "caption": "This is an image caption."
        },
        {  
            "name":"30 Broad 37th Floor",
            "architect":"Montroy Anderson",
            "projdescription": "Law Firm",
            "link": "30-Broad-37th-Floor",
            "cover": "30-Broad-37th-Floor/01.jpg",
            "images": [
                {"link": "30-Broad-37th-Floor/01.jpg", "caption": "This will be the image's caption."},
                // {"link": "30-Broad-37th-Floor/02.jpg", "caption": "This will be the image's caption."},
                {"link": "30-Broad-37th-Floor/05.jpg", "caption": "This will be the image's caption."},
                {"link": "30-Broad-37th-Floor/07.jpg", "caption": "This will be the image's caption."},
                {"link": "30-Broad-37th-Floor/011.jpg", "caption": "This will be the image's caption."},
                {"link": "30-Broad-37th-Floor/013.jpg", "caption": "This will be the image's caption."},
                {"link": "30-Broad-37th-Floor/014.jpg", "caption": "This will be the image's caption."},
                {"link": "30-Broad-37th-Floor/015.jpg", "caption": "This will be the image's caption."}
            ],
            "description": "This will be the project's description once TopBunk Tech acquires all of the needed resources. Please be patient while we wait for those resources to arrive.",
            "about": "This is an area where United Builders Group can inform the user about the project. This could include start and end dates, location of the project, or any information United Builders Group would like to share.",
            "caption": "This is an image caption."
        },
        {  
            "name":"30 Broad 28th Floor",
            "architect":"Montroy Anderson",
            "projdescription": "Music Production",
            "link": "30-Broad-28th-Floor",
            "cover": "30-Broad-28th-Floor/01.jpg",
            "images": [
                {"link": "30-Broad-28th-Floor/01.jpg", "caption": "This will be the image's caption."},
                {"link": "30-Broad-28th-Floor/02.jpg", "caption": "This will be the image's caption."},
                {"link": "30-Broad-28th-Floor/03.jpg", "caption": "This will be the image's caption."},
                {"link": "30-Broad-28th-Floor/04.jpg", "caption": "This will be the image's caption."},
                {"link": "30-Broad-28th-Floor/07.jpg", "caption": "This will be the image's caption."},
                {"link": "30-Broad-28th-Floor/010.jpg", "caption": "This will be the image's caption."},
                {"link": "30-Broad-28th-Floor/011.jpg", "caption": "This will be the image's caption."},
                {"link": "30-Broad-28th-Floor/012.jpg", "caption": "This will be the image's caption."},
                {"link": "30-Broad-28th-Floor/014.jpg", "caption": "This will be the image's caption."}
            ],
            "description": "This will be the project's description once TopBunk Tech acquires all of the needed resources. Please be patient while we wait for those resources to arrive.",
            "about": "This is an area where United Builders Group can inform the user about the project. This could include start and end dates, location of the project, or any information United Builders Group would like to share.",
            "caption": "This is an image caption."
        },
        {  
            "name":"30 Broad Lobby and Prebuilt Offices",
            "architect":"Montroy Anderson",
            "projdescription": "Lobby and Pre-Built Offices",
            "link": "30-Broad-Lobby",
            "cover": "30-Broad-Lobby/01.jpg",
            "images": [
                {"link": "30-Broad-Lobby/01.jpg", "caption": "This will be the image's caption."},
                {"link": "30-Broad-Lobby/02.jpg", "caption": "This will be the image's caption."},
                {"link": "30-Broad-Lobby/03.jpg", "caption": "This will be the image's caption."},
                {"link": "30-Broad-Lobby/04.jpg", "caption": "This will be the image's caption."},
                {"link": "30-Broad-Lobby/06.jpg", "caption": "This will be the image's caption."},
                {"link": "30-Broad-Lobby/07.jpg", "caption": "This will be the image's caption."}
                // {"link": "30-Broad-Lobby/08.jpg", "caption": "This will be the image's caption."}
            ],
            "description": "This will be the project's description once TopBunk Tech acquires all of the needed resources. Please be patient while we wait for those resources to arrive.",
            "about": "This is an area where United Builders Group can inform the user about the project. This could include start and end dates, location of the project, or any information United Builders Group would like to share.",
            "caption": "This is an image caption."
        },
        {  
            "name":"30 Broad Woods Bagot",
            "architect":"Woods Bagot",
            "projdescription": "Architecture Firm",
            "link": "30-Broad-Woods-Bagot",
            "cover": "30-Broad-Woods-Bagot/02.jpg",
            "images": [
                {"link": "30-Broad-Woods-Bagot/02.jpg", "caption": "This will be the image's caption."},
                {"link": "30-Broad-Woods-Bagot/06.jpg", "caption": "This will be the image's caption."},
                {"link": "30-Broad-Woods-Bagot/08.jpg", "caption": "This will be the image's caption."},
                {"link": "30-Broad-Woods-Bagot/010.jpg", "caption": "This will be the image's caption."},
                {"link": "30-Broad-Woods-Bagot/012.jpg", "caption": "This will be the image's caption."},
                {"link": "30-Broad-Woods-Bagot/014.jpg", "caption": "This will be the image's caption."},
                {"link": "30-Broad-Woods-Bagot/015.jpg", "caption": "This will be the image's caption."}
            ],
            "description": "This will be the project's description once TopBunk Tech acquires all of the needed resources. Please be patient while we wait for those resources to arrive.",
            "about": "This is an area where United Builders Group can inform the user about the project. This could include start and end dates, location of the project, or any information United Builders Group would like to share.",
            "caption": "This is an image caption."
        },
        {  
            "name":"130 West 42nd",
            "architect":"Project Architect",
            "projdescription": "Silhouette Gallery",
            "link": "130-West-42nd",
            "cover": "130-West-42nd/03.jpg",
            "images": [
                {"link": "130-West-42nd/02.jpg", "caption": "This will be the image's caption."},
                {"link": "130-West-42nd/03.jpg", "caption": "This will be the image's caption."},
                {"link": "130-West-42nd/04.jpg", "caption": "This will be the image's caption."},
                {"link": "130-West-42nd/08.jpg", "caption": "This will be the image's caption."},
                {"link": "130-West-42nd/010.jpg", "caption": "This will be the image's caption."},
                {"link": "130-West-42nd/018.jpg", "caption": "This will be the image's caption."},
                {"link": "130-West-42nd/020.jpg", "caption": "This will be the image's caption."}
                // {"link": "130-West-42nd/022.jpg", "caption": "This will be the image's caption."}
            ],
            "description": "This will be the project's description once TopBunk Tech acquires all of the needed resources. Please be patient while we wait for those resources to arrive.",
            "about": "This is an area where United Builders Group can inform the user about the project. This could include start and end dates, location of the project, or any information United Builders Group would like to share.",
            "caption": "This is an image caption."
        },
        {  
            "name":"87 Leonard",
            "architect":"Project Architect",
            "projdescription": "High End Residential",
            "link": "87-Leonard",
            "cover": "87-Leonard/01.jpg",
            "images": [
                {"link": "87-Leonard/05.jpg", "caption": "This will be the image's caption."},
                {"link": "87-Leonard/01.jpg", "caption": "This will be the image's caption."},
                {"link": "87-Leonard/02.jpg", "caption": "This will be the image's caption."},
                {"link": "87-Leonard/06.jpg", "caption": "This will be the image's caption."},
                {"link": "87-Leonard/04.jpg", "caption": "This will be the image's caption."}
                // {"link": "87-Leonard/06.jpg", "caption": "This will be the image's caption."}
            ],
            "description": "This will be the project's description once TopBunk Tech acquires all of the needed resources. Please be patient while we wait for those resources to arrive.",
            "about": "This is an area where United Builders Group can inform the user about the project. This could include start and end dates, location of the project, or any information United Builders Group would like to share.",
            "caption": "This is an image caption."
        },
        {  
            "name":"641 Avenue of the Americas",
            "architect":"Project Architect",
            "projdescription": "Teknion Showroom",
            "link": "641-Avenue-of-the-Americas",
            "cover": "641-Avenue-of-the-Americas/01.jpg",
            "images": [
                {"link": "641-Avenue-of-the-Americas/01.jpg", "caption": "This will be the image's caption."},
                {"link": "641-Avenue-of-the-Americas/04.jpg", "caption": "This will be the image's caption."},
                {"link": "641-Avenue-of-the-Americas/05.jpg", "caption": "This will be the image's caption."},
                {"link": "641-Avenue-of-the-Americas/06.jpg", "caption": "This will be the image's caption."},
                {"link": "641-Avenue-of-the-Americas/08.jpg", "caption": "This will be the image's caption."}
            ],
            "description": "This will be the project's description once TopBunk Tech acquires all of the needed resources. Please be patient while we wait for those resources to arrive.",
            "about": "This is an area where United Builders Group can inform the user about the project. This could include start and end dates, location of the project, or any information United Builders Group would like to share.",
            "caption": "This is an image caption."
        },
        {  
            "name":"150 Columbus",
            "architect":"Project Architect",
            "projdescription": "Residential Three Project Merge",
            "link": "150-Columbus",
            "cover": "150-Columbus/05.jpg",
            "images": [
                {"link": "150-Columbus/02.jpg", "caption": "This will be the image's caption."},
                {"link": "150-Columbus/05.jpg", "caption": "This will be the image's caption."},
                {"link": "150-Columbus/06.jpg", "caption": "This will be the image's caption."},
                {"link": "150-Columbus/08.jpg", "caption": "This will be the image's caption."},
                {"link": "150-Columbus/09.jpg", "caption": "This will be the image's caption."}
            ],
            "description": "This will be the project's description once TopBunk Tech acquires all of the needed resources. Please be patient while we wait for those resources to arrive.",
            "about": "This is an area where United Builders Group can inform the user about the project. This could include start and end dates, location of the project, or any information United Builders Group would like to share.",
            "caption": "This is an image caption."
        },   
    ]
